export default "__VITE_ASSET__DYEWJ7KF__"